/* Evenly quiz: one screen at a time, legs/arms paths, optional email, personalized results */
(function () {
  var root = document.querySelector('[data-pq]');
  if (!root || root.classList.contains('pq--editing')) return; // the theme editor shows every screen stacked

  var STORE = 'evenly-quiz-v1';
  var steps = [].slice.call(root.querySelectorAll('[data-pq-step]'));
  var resultStep = root.querySelector('[data-pq-step="result"]');
  var bar = root.querySelector('[data-pq-bar]');
  var counter = root.querySelector('[data-pq-count]');
  var backBtn = root.querySelector('[data-pq-back]');
  var current = steps[0];
  var history = [];
  var answers = {};
  var concern = null; // 'legs' | 'arms' | 'both'
  var EXCLUSIVE_LAST = ['tried', 'safety'];

  function clean(label) {
    return String(label || '').replace(/^[^\p{L}\p{N}]+/u, '').trim();
  }
  function lowerFirst(s) { return s ? s.charAt(0).toLowerCase() + s.slice(1) : s; }
  function upperFirst(s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; }
  function listText(items) {
    if (items.length < 2) return items.join('');
    return items.slice(0, -1).join(', ') + ' and ' + items[items.length - 1];
  }
  function track(name, data) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data || {}); } catch (e) {}
    try { if (window.fbq) window.fbq('trackCustom', name, data || {}); } catch (e) {}
  }
  function ans(key) { return answers[key] || { idx: [], labels: [], notes: [], count: 0 }; }
  function first(key) { var a = ans(key); return a.idx.length ? a.idx[0] : -1; }

  // Which screens are in this visitor's path
  function inPath(step) {
    var p = step.dataset.path || 'all';
    var c = concern || 'legs'; // until she answers, count the legs path
    if (p === 'all') return true;
    if (p === 'arms_only') return c === 'arms';
    return p === 'legs' ? c !== 'arms' : c !== 'legs';
  }
  function flow() {
    return steps.filter(function (s) {
      var t = s.dataset.pqStep;
      return (t === 'question' || t === 'info' || t === 'why_failed') ? inPath(s) : true;
    });
  }

  function updateChrome() {
    var f = flow();
    var t = current.dataset.pqStep;
    var pct = 0;
    if (t === 'result') pct = 100;
    else if (t !== 'intro') pct = Math.round(f.indexOf(current) / f.indexOf(resultStep) * 100);
    bar.style.width = pct + '%';
    var qs = f.filter(function (s) { return s.dataset.pqStep === 'question'; });
    var qi = qs.indexOf(current);
    counter.textContent = qi > -1 ? (qi + 1) + '/' + qs.length : '';
    var canBack = history.length > 0 && t !== 'loading' && t !== 'result';
    backBtn.classList.toggle('is-visible', canBack);
  }

  function show(step, remember) {
    if (remember !== false && current) history.push(current);
    current.classList.remove('is-active');
    step.classList.add('is-active');
    current = step;
    window.scrollTo(0, 0);
    updateChrome();
    enter(step);
  }
  function next() {
    var f = flow();
    var n = f[f.indexOf(current) + 1];
    if (n) show(n);
  }
  function back() {
    var prev = history.pop();
    while (prev && prev.dataset.pqStep === 'loading') prev = history.pop();
    if (prev) show(prev, false);
  }

  // Answers
  function record(step) {
    var key = step.dataset.key;
    var chosen = [].slice.call(step.querySelectorAll('.pq-opt.is-selected'));
    answers[key] = {
      idx: chosen.map(function (o) { return +o.dataset.index; }),
      labels: chosen.map(function (o) { return clean(o.dataset.label); }),
      notes: chosen.map(function (o) { return o.dataset.note || ''; }),
      count: step.querySelectorAll('.pq-opt').length
    };
    if (key === 'concern') concern = ['legs', 'arms', 'both'][answers[key].idx[0]] || 'legs';
  }

  root.querySelectorAll('[data-pq-step="question"]').forEach(function (step) {
    var multi = step.dataset.multi === 'true';
    var opts = [].slice.call(step.querySelectorAll('.pq-opt'));
    var nextBtn = step.querySelector('[data-pq-next]');
    var exclusiveLast = EXCLUSIVE_LAST.indexOf(step.dataset.key) > -1;
    opts.forEach(function (opt, i) {
      opt.addEventListener('click', function () {
        if (!multi) {
          opts.forEach(function (o) { o.classList.remove('is-selected'); o.setAttribute('aria-pressed', 'false'); });
          opt.classList.add('is-selected');
          opt.setAttribute('aria-pressed', 'true');
          record(step);
          setTimeout(next, 220);
          return;
        }
        var on = !opt.classList.contains('is-selected');
        if (on && exclusiveLast) {
          var isLast = i === opts.length - 1;
          opts.forEach(function (o, j) {
            if (isLast ? j !== i : j === opts.length - 1) { o.classList.remove('is-selected'); o.setAttribute('aria-pressed', 'false'); }
          });
        }
        opt.classList.toggle('is-selected', on);
        opt.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (nextBtn) nextBtn.disabled = !step.querySelector('.pq-opt.is-selected');
      });
    });
    if (nextBtn) nextBtn.addEventListener('click', function () { record(step); next(); });
  });

  root.querySelectorAll('[data-pq-step="info"] [data-pq-next], [data-pq-step="why_failed"] [data-pq-next]').forEach(function (btn) {
    btn.addEventListener('click', next);
  });
  root.querySelector('[data-pq-start]').addEventListener('click', function () { track('quiz_started'); next(); });
  backBtn.addEventListener('click', back);

  // Screen-specific behavior when a screen opens
  function enter(step) {
    var t = step.dataset.pqStep;
    if (t === 'why_failed') fillWhyFailed(step);
    if (t === 'loading') runLoading(step);
    if (t === 'result') buildResult();
  }

  function triedPicks() {
    var a = ans('tried');
    var out = [];
    a.idx.forEach(function (ix, k) {
      if (ix === a.count - 1) return; // "Nothing yet"
      out.push({ label: a.labels[k], note: a.notes[k] });
    });
    return out;
  }

  function fillWhyFailed(step) {
    var list = step.querySelector('[data-pq-failed-list]');
    var outro = step.querySelector('[data-pq-failed-outro]');
    var picks = triedPicks();
    list.innerHTML = '';
    picks.forEach(function (p) {
      var li = document.createElement('li');
      li.innerHTML = '<span class="pq-x" aria-hidden="true">✕</span><span><b></b><br><span></span></span>';
      li.querySelector('b').textContent = p.label;
      li.querySelector('span span').textContent = p.note;
      list.appendChild(li);
    });
    list.hidden = !picks.length;
    if (!outro.dataset.original) outro.dataset.original = outro.textContent;
    outro.textContent = picks.length ? outro.dataset.original : (outro.dataset.none || outro.dataset.original);
  }

  function runLoading(step) {
    var ring = step.querySelector('[data-pq-ring]');
    var pctEl = step.querySelector('[data-pq-pct]');
    var items = [].slice.call(step.querySelectorAll('li'));
    items.forEach(function (li) { li.classList.remove('is-done'); });
    var start = null;
    var duration = 3200;
    function frame(ts) {
      if (!start) start = ts;
      var p = Math.min(1, (ts - start) / duration);
      ring.style.strokeDashoffset = String(327 * (1 - p));
      pctEl.textContent = Math.round(p * 100) + '%';
      items.forEach(function (li, i) { if (p >= (i + 1) / items.length) li.classList.add('is-done'); });
      if (p < 1) window.requestAnimationFrame(frame);
      else setTimeout(next, 350);
    }
    window.requestAnimationFrame(frame);
  }

  // Email (optional, always skippable)
  var form = root.querySelector('[data-pq-email-form]');
  if (form) {
    var errorEl = root.querySelector('[data-pq-email-error]');
    root.querySelector('[data-pq-skip]').addEventListener('click', next);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = form.email.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
        errorEl.textContent = 'Please enter a valid email, or skip below.';
        return;
      }
      errorEl.textContent = '';
      var btn = form.querySelector('button[type=submit]');
      btn.disabled = true;
      var done = false;
      var finish = function () { if (done) return; done = true; btn.disabled = false; next(); };
      setTimeout(finish, 4000); // never hold her results hostage to a slow request
      subscribe(email).then(function () { track('quiz_lead', { concern: concern }); try { if (window.fbq) window.fbq('track', 'Lead'); } catch (er) {} }).catch(function () {}).then(finish);
    });
  }

  function subscribe(email) {
    var props = {
      quiz_concern: concern,
      quiz_areas: ans('areas').labels.join(', '),
      quiz_tried: ans('tried').labels.join(', '),
      quiz_age: ans('age').labels.join(''),
      quiz_time: ans('time').labels.join('')
    };
    var company = root.dataset.klaviyoCompany;
    var list = root.dataset.klaviyoList;
    if (company && list) {
      return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: 'Evenly quiz', profile: { data: { type: 'profile', attributes: { email: email, properties: props } } } }, relationships: { list: { data: { type: 'list', id: list } } } } })
      });
    }
    var tags = (root.dataset.tags || '').split(',').map(function (t) { return t.trim(); }).filter(Boolean);
    tags.push('quiz-' + (concern || 'legs'));
    var body = new FormData();
    body.append('form_type', 'customer');
    body.append('utf8', '✓');
    body.append('contact[email]', email);
    body.append('contact[tags]', tags.join(','));
    return fetch('/contact', { method: 'POST', body: body, credentials: 'same-origin' });
  }

  // Results
  function addDays(n) { var d = new Date(); d.setDate(d.getDate() + n); return d; }
  function fmt(d) { return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' }); }

  function buildResult() {
    var legs = concern !== 'arms';
    var arms = concern === 'arms' || concern === 'both';
    var r = resultStep;

    r.querySelector('[data-pq-result-title]').textContent = r.dataset['title' + (concern === 'arms' ? 'Arms' : concern === 'both' ? 'Both' : 'Legs')];

    // Safety note
    var safety = ans('safety');
    var flags = [];
    safety.idx.forEach(function (ix, k) { if (ix !== safety.count - 1) flags.push(lowerFirst(safety.labels[k])); });
    var alert = r.querySelector('[data-pq-safety]');
    alert.hidden = !flags.length;
    if (flags.length) alert.textContent = r.dataset.safety.replace('{items}', listText(flags));

    // Profile
    var areas = legs ? ans('areas').labels.map(lowerFirst) : [];
    if (arms) areas.push('upper arms');
    if (!areas.length) areas.push('thighs');
    var seen = [];
    if (legs && ans('severity').labels.length) seen.push(ans('severity').labels[0]);
    if (arms && ans('arm_texture').labels.length) seen.push(ans('arm_texture').labels[0]);
    var sensitive = first('sensitivity') === 0 || first('sensitivity') === 1;
    var timeIx = first('time');
    var profile = [
      ['Focus areas', upperFirst(listText(areas))],
      ['What you notice', seen.join(' · ') || '—'],
      ['Starting level', sensitive ? 'Level 1, extra gentle' : 'Level 1'],
      ['Time per night', ans('time').labels[0] || '10 minutes']
    ];
    if (ans('age').labels.length) profile.push(['Age', ans('age').labels[0]]);
    var dl = r.querySelector('[data-pq-profile]');
    dl.innerHTML = '';
    profile.forEach(function (p) {
      var div = document.createElement('div');
      var dt = document.createElement('dt'); dt.textContent = p[0];
      var dd = document.createElement('dd'); dd.textContent = p[1];
      div.appendChild(dt); div.appendChild(dd); dl.appendChild(div);
    });

    // Routine
    var minutes = [5, 10, 15, 10][timeIx] || 10;
    var perNight = Math.max(1, Math.floor(minutes / 5));
    var routine = [
      'Smooth a little oil over your ' + listText(areas) + '.',
      sensitive
        ? 'Start on level 1 with gentle heat, and stay on level 1 for your first 2 weeks, since you\'ve had bruising or discomfort before.'
        : 'Start on level 1 with gentle heat. Only move up a level when it feels easy.',
      'Glide slowly upward, about 5 minutes per area' + (areas.length > perNight
        ? '. With ' + minutes + ' minutes, do ' + perNight + ' area' + (perNight > 1 ? 's' : '') + ' a night and rotate.'
        : ', about ' + Math.min(minutes, areas.length * 5) + ' minutes in total.'),
      'Do it 4–5 nights a week for 8 weeks, then 2–3 nights a week to maintain.'
    ];
    if (arms) routine.splice(3, 0, 'Use a lighter touch on your arms. The skin there is thinner than on your thighs.');
    var ol = r.querySelector('[data-pq-routine]');
    ol.innerHTML = '';
    routine.forEach(function (s, i) {
      var li = document.createElement('li');
      li.innerHTML = '<span class="pq-routine__n">' + (i + 1) + '</span><span></span>';
      li.lastChild.textContent = s;
      ol.appendChild(li);
    });

    // What she tried
    var picks = triedPicks().filter(function (p) { return p.note; });
    var triedCard = r.querySelector('[data-pq-tried-card]');
    var triedList = r.querySelector('[data-pq-tried]');
    triedList.innerHTML = '';
    picks.forEach(function (p) {
      var li = document.createElement('li');
      li.innerHTML = '<span class="pq-x" aria-hidden="true">✕</span><span><b></b><br><span></span></span>';
      li.querySelector('b').textContent = p.label;
      li.querySelector('span span').textContent = p.note;
      triedList.appendChild(li);
    });
    triedCard.hidden = !picks.length;

    // Before/after for her path
    r.querySelectorAll('[data-pq-ba]').forEach(function (el) {
      el.hidden = el.dataset.pqBa === 'legs' ? !legs : !arms;
    });

    // Timeline dates: assume the kit arrives in about a week
    var arrival = 7;
    var lastDay = 56;
    r.querySelectorAll('[data-pq-timeline] li').forEach(function (li) {
      var day = parseInt(li.dataset.day, 10);
      if (!isNaN(day)) { li.querySelector('[data-pq-date]').textContent = ' · ' + fmt(addDays(arrival + day)); lastDay = day; }
    });
    var ev = ans('event');
    var evEl = r.querySelector('[data-pq-event]');
    var hasEvent = ev.idx.length && ev.idx[0] !== ev.count - 1;
    evEl.hidden = !hasEvent;
    if (hasEvent) evEl.textContent = r.dataset.eventLine.replace('{date}', fmt(addDays(arrival + lastDay))).replace('{event}', lowerFirst(ev.labels[0]));

    // CTA keeps the ad's tracking and notes the quiz path
    var cta = r.querySelector('[data-pq-cta]');
    var href = root.dataset.ctaUrl + (root.dataset.ctaUrl.indexOf('?') > -1 ? '&' : '?') + 'quiz=' + (concern || 'legs');
    cta.setAttribute('href', window.prWithQuery ? window.prWithQuery(href) : href);

    try { sessionStorage.setItem(STORE, JSON.stringify({ answers: answers, concern: concern })); } catch (e) {}
    track('quiz_completed', { concern: concern, areas: areas.join(', ') });
  }

  // Restart
  root.querySelector('[data-pq-restart]').addEventListener('click', function () {
    try { sessionStorage.removeItem(STORE); } catch (e) {}
    answers = {};
    concern = null;
    history = [];
    root.querySelectorAll('.pq-opt.is-selected').forEach(function (o) { o.classList.remove('is-selected'); o.setAttribute('aria-pressed', 'false'); });
    root.querySelectorAll('[data-pq-next]').forEach(function (b) { if (b.closest('[data-multi="true"]')) b.disabled = true; });
    show(steps[0], false);
  });

  // Coming back from the product page: show her results again instead of the intro
  try {
    var saved = JSON.parse(sessionStorage.getItem(STORE) || 'null');
    if (saved && saved.answers) {
      answers = saved.answers;
      concern = saved.concern;
      show(resultStep, false);
      return;
    }
  } catch (e) {}
  updateChrome();
})();
